<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)" >返回</a>
        <h1>{{dateString}}</h1>
        <a class="pull-right icon-right icon-setup text-hide" @click.prevent="popupVisibleHomework = true">发起</a>
      </div>
      <div class="liner"></div>
    </div>

    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page homework" style="padding-bottom:60px;">
      <div class="padding-15 group">
        <ul class="clearfix text-center">
          <li class="col-xs-4" v-for="item in classHomeworkList" @click="selectClass(item)">
            <a href="javascript:;" v-bind:class="{'active': item.className == selectClassName}">{{item.className}} <span>{{item.count}}</span></a>
          </li>
        </ul>
      </div>
      <!-- 未读作业 -->
      <div v-for="item in homeworkObj.wdList" v-show="isShowWd">
        <div class="padding-15" v-bind:class="{'teacher' : item.clientType == 'teacher', 'parents' : item.clientType == 'parents'}" >
          <div class="clearfix">
            <div class="header-pic">
              <a class="block">
                <span class="img-wrap small block"><img :src="item.imageAddress ? baseAcessPath + item.imageAddress : img_default" /></span>
              </a>
            </div>
            <div class="content">
              <span class="who">{{item.studentName + (item.clientType == 'teacher' ? ('【 ' + item.userName + '老师 】') : '【 ' + item.userName + '】')}} -&nbsp;&nbsp;&nbsp;{{item.publishDate | dateDiff}}</span>
              <div class="wrap">
                <i></i>
                <cite v-if="item.field1 == '0'"></cite>
                <router-link :to="{path: '/homework/detail/' + item.homeWorkId}">{{item.content}}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="homeworkObj.wdList == 0 && isShowWd" class="text-center" style="padding-top:200px">暂无待阅作业</div>
      <!-- 已读作业 -->
      <div v-for="item in homeworkObj.ydList" v-show="!isShowWd">
        <div class="padding-15" v-bind:class="{'teacher' : item.clientType == 'teacher', 'parents' : item.clientType == 'parents'}" >
          <div class="clearfix">
            <div class="header-pic">
              <a class="block">
                <span class="img-wrap small block"><img :src="item.imageAddress ? baseAcessPath + item.imageAddress : img_default" /></span>
              </a>
            </div>
            <div class="content">
              <span class="who">{{item.studentName + (item.clientType == 'teacher' ? ('【 ' + item.userName + '老师 】') : '【 ' + item.userName + '】')}} -&nbsp;&nbsp;&nbsp;{{item.publishDate | dateDiff}}</span>
              <div class="wrap">
                <i></i>
                <cite v-if="item.field1 == '0'"></cite>
                <router-link :to="{path: '/homework/detail/' + item.homeWorkId}">{{item.content}}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="homeworkObj.ydList == 0 && !isShowWd" class="text-center padding-15" style="padding-top:200px">暂无已阅作业</div>
    </div>
    </mt-loadmore>

    <!-- 选择学生 -->
    <dialogStudents :isHideSelectStudent="isHideSelectStudent" :studentFirstCharList="studentFirstCharList" v-on:close="closeDialogStudents" v-on:selected="selectedStudent"></dialogStudents>

    <div class="bottom-bar" style="z-index:999">
      <div class="liner"></div>
      <ul class="clearfix">
        <li class="col-xs-6 bottom-option" @click="isShowWd = true"><a class="block text-center" href="javascript:;"><span v-bind:class="{'active': isShowWd}">待阅{{homeworkObj.wdList && homeworkObj.wdList.length}}</span></a></li>
        <li class="col-xs-6 bottom-option clearfix" @click="isShowWd = false"><a class="block text-center line-y" href="javascript:;"><span v-bind:class="{'active': !isShowWd}">已阅{{homeworkObj.ydList && homeworkObj.ydList.length}}</span></a></li>
      </ul>
    </div>

    <mt-popup v-model="popupVisibleHomework" position="bottom">
      <div class="shall text-center" style="width:100vw" @click="popupVisibleHomework = false">
      <div class="clearfix margin-15 font-12">
        <div class="col-xs-4"><router-link class="icon-add icon gray" :to="{path: '/homework/add'}">新增一条</router-link></div>
        <div class="col-xs-4"><a class="icon-histroy icon gray" @click.prevent="openPicker('picker')">以前的作业</a></div>
        <div class="col-xs-4"><a class="icon-find icon gray" @click.prevent="isHideSelectStudent = false">查看TA的作业</a></div>
      </div>
      <ul class="list-group-item tinny" style="margin:0">
        <li class="list-group">
          <div class="liner"></div>
          <span class="group-txt">取消</span>
        </li>
      </ul>
    </div>
    </mt-popup>

    <mt-datetime-picker v-model="filterTime" type="date" @confirm="handleChange" ref="picker"></mt-datetime-picker>
  </div>
</template>

<script>
import { service } from '../../service'
import { mapGetters, mapMutations } from 'vuex'
// component
import dialogStudents from '../../components/student/dialogStudents'

export default {
  computed: mapGetters({
    studentFirstCharList: 'getStudentsByFirstChar',
    vuexHomework: 'vuexHomework'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      curcheId: 0,
      teacherId: 0,
      get_homework_list_para: service.setPara('getHomeWorkList'),
      get_new_student_list_para: service.setPara('getNewStudentList'),
      homeworkList: [],
      homeworkObj: {className: '全部', wdNum: 0, ydNum: 0, count: 0, list: []},
      classHomeworkList: [],
      popupVisibleHomework: false,
      isShowWd: true,
      dateString: '今日作业',
      listTimeVisible: false,
      filterTime: new Date(),
      baseAcessPath: '',
      selectClassName: '全部',
      isHideSelectStudent: true
    }
  },
  components: {
    dialogStudents
  },
  mounted: function () {
    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId
    this.baseAcessPath = this.cookie_login_data.baseAcessPath

    this.get_new_student_list_para.curcheId = this.curcheId
    this.get_new_student_list_para.sfzt = '在托'
    this.get_new_student_list_para.context = this
    this.$store.dispatch('receiveStudents', this.get_new_student_list_para)

    this.get_homework_list_para.curcheId = this.curcheId
    this.get_homework_list_para.teacherId = this.teacherId

    let flag = true
    let obj = this.vuexHomework.all
    if (this.vuexHomework.flag) {
      if ((new Date().getTime() - this.vuexHomework.time) < 300 * 1000 && obj.para.curcheId == this.curcheId && obj.para.teacherId == this.teacherId) { // 5分钟刷一下
        this.dateString = obj.dateString
        this.isShowWd = obj.isShowWd
        this.get_homework_list_para.publishDate = obj.para.publishDate
        let jsonStr = JSON.stringify(obj.list)
        this.homeworkList = JSON.parse(jsonStr)
        this.getHomeworkListByType()
        this.getHomeworkListAll()
        for (let i = 0; i < this.classHomeworkList.length; i++) {
          if (this.classHomeworkList[i].className == obj.selectClassName) {
            this.selectClass(this.classHomeworkList[i])
            break
          }
        }
        flag = false
      }
    }
    if (flag) {
      this.get_homework_list_para.publishDate = new Date().format('yyyy-MM-dd')
      this.getHomeworkList()
    }
  },
  methods: {
    ...mapMutations([
      'receiveStudents',
      'receiveHomeworkList'
    ]),
    openPicker (picker) {
      this.$refs[picker].open()
    },
    loadTop (id) {
      this.selectClassName = '全部'
      this.getHomeworkList()
      this.$refs.loadmore.onTopLoaded(id)
    },
    getHomeworkList: function () { // 获取作业列表
      let obj = {context: this, para: this.get_homework_list_para, isIndicator: false, successFun: (response) => {
        this.homeworkList = response.data.list
        this.getHomeworkListByType()
        this.getHomeworkListAll()
      }}
      service.request(obj)
    },
    getHomeworkListAll () {
      let allHomework = {}
      allHomework.className = '全部'
      allHomework.count = 0
      allHomework.wdList = []
      allHomework.ydList = []
      this.homeworkList.forEach((item, i) => {
        let alreadyExists = allHomework.wdList.some((newItem, j) => {
          if (item.homeWorkId == newItem.homeWorkId) {
            return true
          }
        })
        if (!alreadyExists) { // 继续查找
          alreadyExists = allHomework.ydList.some((newItem, j) => {
            if (item.homeWorkId == newItem.homeWorkId) {
              return true
            }
          })
        }

        if (!alreadyExists) {
          if (item.state == 0) {
            allHomework.wdList.push(item)
          } else {
            allHomework.ydList.push(item)
          }
          allHomework.count++
        }
      })
      this.classHomeworkList.unshift(allHomework)
      this.homeworkObj = this.classHomeworkList[0]
    },
    getHomeworkListByType () {
      this.classHomeworkList = []
      this.homeworkList.forEach((item, i) => {
        if (!item.className) {
          return
        }
        let index = -1
        let alreadyExists = this.classHomeworkList.some((newItem, j) => {
          if (item.className == newItem.className) {
            index = j
            return true
          }
        })

        if (!alreadyExists) {
          let wdList = []
          let ydList = []
          if (item.state == 0) {
            wdList = [item]
          } else {
            ydList = [item]
          }
          this.classHomeworkList.push({
            className: item.className,
            wdList: wdList,
            ydList: ydList,
            count: 1,
            list: [item]
          })
        } else {
          if (item.state == 0) {
            this.classHomeworkList[index].wdList.push(item)
          } else {
            this.classHomeworkList[index].ydList.push(item)
          }
          this.classHomeworkList[index].count++
        }
      })
    },
    selectClass (item) {
      this.selectClassName = item.className
      this.homeworkObj = item
    },
    handleChange (value) {
      this.get_homework_list_para.publishDate = value.format('yyyy-MM-dd')
      if (this.get_homework_list_para.publishDate == new Date().format('yyyy-MM-dd')) {
        this.dateString = '今日作业'
      } else {
        this.dateString = this.get_homework_list_para.publishDate
      }
      this.selectClassName = '全部'
      this.getHomeworkList()
    },
    closeDialogStudents () { // 关闭选择学生弹出框
      this.isHideSelectStudent = true
    },
    selectedStudent (student) {
      this.$router.push('/homework/student/list/' + student.studentId + '/' + student.studentName)
    }
  },
  beforeDestroy: function () {
    let obj = {}
    // obj.scrollTop = this.scrollTop
    obj.list = this.homeworkList
    obj.selectClassName = this.selectClassName
    obj.isShowWd = this.isShowWd
    obj.para = this.get_homework_list_para
    obj.dateString = this.dateString
    this.$store.dispatch('receiveHomeworkList', obj)
  }
}
</script>
<style scoped>
  .main-page{padding-bottom:45px;}
  .group-link{padding:10px 50px 10px 15px}
</style>


// WEBPACK FOOTER //
// homeworkList.vue?61238cc5